import React from 'react';
import { themes } from '../../css/theme';

export const ThemeContext = React.createContext(
    // themes.blue // default value
    themes.blue,
    themes
);
